import React, { useEffect } from 'react';
import { RootState } from '../../../store/store';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { handleCustomerInfoChange } from '../ShoppingCartSliceV2';
export const generateUUID = () => {
  const currentTime = Date.now();
  const number = Math.floor(Math.random() * 10000000000000 + 1);
  // CREATION TIME + RANDOM NUMBER
  return String('t' + currentTime + '_' + number);
};
const useHandleCheckout = (isCheckoutPage: boolean) => {
  const { shoppingCart } = useSelector(
    (state: RootState) => state.shoppingCart
  );
  const { settings } = useSelector((state: RootState) => state.shoppingCart);
  const { customerInfo } = useSelector(
    (data: RootState) => data.shoppingCartV2
  );

  const customerInfoModifiedKeys = {
    customer_phone: customerInfo.phone,
    customer_first_name: customerInfo.first_name,
    customer_last_name: customerInfo.last_name,
    customer_email: customerInfo.email,
    user_comment: customerInfo.comment,
  };

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const handleCheckout = () => {
    // // make sure the guests array is not less than sum of flights package passengers amount
    // console.log("123 ShoppingCartV2 -> ", ShoppingCartV2);
    // let totalFlightPackagePassengers = 0;
    // ShoppingCartV2?.products?.forEach((product: any) => {
    //   if (product.type === 'package') {

    //   }
    // });

    // if (ShoppingCartV2.guests.length < 20) {
    //   return
    // }

    const uuid = generateUUID();
    const prevData = localStorage.getItem('cart');
    const parsedPrevData = JSON.parse(prevData ?? '{}');
    localStorage.setItem(
      'cart',
      JSON.stringify({
        ...parsedPrevData,
        [uuid]: { shoppingCart, time: Date.now(), settings },
      })
    );

    navigate('/checkout/' + uuid);
  };

  useEffect(() => {
    const hasAgentCustomer = !!(
      customerInfo?.first_name ||
      customerInfo?.last_name ||
      customerInfo?.phone ||
      customerInfo?.email ||
      customerInfo?.customer_secret
    );
    // Don't sync empty agent customer over cart — initial state is empty until
    // useInitializeCurrentCustomer hydrates from localStorage; wiping here races
    // OrderDetailsForm.transformGuestData and leaves Form.Item values blank.
    if (!isCheckoutPage && hasAgentCustomer) {
      dispatch(handleCustomerInfoChange(customerInfoModifiedKeys));
    }
  }, [customerInfo, dispatch]);

  return handleCheckout;
};

export default useHandleCheckout;
